import { render } from "./ChooseArea.vue?vue&type=template&id=51d3444a&scoped=true"
import script from "./ChooseArea.vue?vue&type=script&lang=js"
export * from "./ChooseArea.vue?vue&type=script&lang=js"

import "./ChooseArea.vue?vue&type=style&index=0&id=51d3444a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3ca827165d99699ca1e09c2bcd03c6d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d3444a"]])

export default __exports__